import { render } from "./trialFome.vue?vue&type=template&id=00ade765&scoped=true"
import script from "./trialFome.vue?vue&type=script&lang=js"
export * from "./trialFome.vue?vue&type=script&lang=js"

import "./trialFome.vue?vue&type=style&index=0&id=00ade765&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4_webpack@5.86.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ade765"]])

export default __exports__